export default __webpack_public_path__ + "114ef555bad6a728ae6036bea0fb4ce0.svg";